/**
 * External dependencies
 */
import { View } from 'react-native';

/**
 * GeChiUI dependencies
 */
import { withPreferredColorScheme } from '@gechiui/compose';

/**
 * Internal dependencies
 */
import styles from './style.scss';

const ToolbarGroupContainer = ( {
	getStylesFromColorScheme,
	passedStyle,
	children,
} ) => (
	<View
		style={ [
			getStylesFromColorScheme( styles.container, styles.containerDark ),
			passedStyle,
		] }
	>
		{ children }
	</View>
);

export default withPreferredColorScheme( ToolbarGroupContainer );
